import store from '@/store/store'
import { computed } from 'vue'
import { Voicebot } from '@voicenter-team/events-sdk'

export function useVoiceBotsState () {
    const allBots = computed(() => store.getters['voicebots/allVoiceBots'] as Voicebot[])

    return {
        allBotsWithCalls: allBots
    }
}
